<script setup lang="ts">
import LoadingSpinner from "@/shared/components/loading/LoadingSpinner.vue";
import {getCurrentInstance, reactive, ref} from "vue";
const { $alert } = getCurrentInstance().appContext.config.globalProperties;
const { $axios } = getCurrentInstance().appContext.config.globalProperties;
const { $endpoint } = getCurrentInstance().appContext.config.globalProperties;
const eventRoomOneForm = reactive({
  applicant_gender:"",
  applicant_last_name:"",
  applicant_first_name:"",
  applicant_town:"",
  applicant_contact:"",
  applicant_wha_contact:"",
  room_name:"Salle de conférence",
  room_picture:"ppppppp",
  start_date:"",
  end_date:"",
  start_hour:"",
  end_hour:"",
  guest:25,
  desc:""
})
const load = ref(false)
const formValidator = () =>{
  return eventRoomOneForm.applicant_last_name == ""
      || eventRoomOneForm.applicant_first_name ==""
      || eventRoomOneForm.applicant_town ==""
      || eventRoomOneForm.applicant_contact.length < 10
      || eventRoomOneForm.applicant_wha_contact.length < 10
      || eventRoomOneForm.start_date ==""
      || eventRoomOneForm.end_date ==""
      || eventRoomOneForm.start_hour ==""
      || eventRoomOneForm.end_hour ==""
      || eventRoomOneForm.desc == ""
}
const sendEventDatas = ()=>{
  load.value = true
  if (formValidator()){
    $alert.fire({
      title: 'Ooops!',
      text: 'Veuillez correctement remplir le formulaire',
      icon: 'error',
      confirmButtonColor:'#D62F2F',
      confirmButtonText: 'Compris'
    })
    load.value  =false
  }else {
    $axios.post($endpoint.BookingEventRoom, eventRoomOneForm).then((resp:any)=>{
      console.error(resp)
      $alert.fire({
        title: 'Opération réussie!',
        text: resp.data.message,
        icon: 'success',
        confirmButtonColor:'#D62F2F',
        confirmButtonText: 'Compris'
      })
      load.value = false
    }).catch((err:any)=>{
      load.value = false
      console.error(err)
    })
  }
}
</script>

<template>
  <div class="uk-container uk-margin-top">
    <div class="uk-container-large uk-margin-top border-outline">
      <loading-spinner v-if="load"></loading-spinner>
      <h6 class="uk-heading-line uk-text-center uk-text-secondary uk-text-uppercase uk-text-bold"><span>Merci de compléter les informations concernant la réservation.</span></h6>
      <form class="uk-grid-large" data-uk-grid>
        <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
          <div class="uk-form-controls uk-position-relative">
            <label class="uk-form-label" for="form-guest-select">Civilité</label>
            <span class="uk-form-icon select-icon" data-uk-icon="icon: users"></span>
            <select class="uk-select uk-border-rounded" v-model="eventRoomOneForm.applicant_gender" id="form-guest-select">
              <option value="M." selected>Monsieur</option>
              <option value="Mme">Madame</option>
              <option value="Mlle">Mademoiselle</option>
            </select>
          </div>
        </div>

        <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
          <label class="uk-form-label" for="form-horizontal-text">Votre noms</label>
          <div class="uk-inline">
            <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: user"></span>
            <input v-model="eventRoomOneForm.applicant_last_name" class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" placeholder="Votre Nons" type="tel"  aria-label="Not clickable icon">
          </div>
        </div>
        <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
                <label class="uk-form-label" for="form-horizontal-text">Votre prénoms</label>
                <div class="uk-inline">
                  <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: user"></span>
                  <input class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" v-model="eventRoomOneForm.applicant_first_name" placeholder="Votre Prénoms" type="text" aria-label="Not clickable icon">
                </div>
         </div>
        <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
                <label class="uk-form-label" for="form-horizontal-text">Votre Ville/commune</label>
                <div class="uk-inline">
                  <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: home"></span>
                  <input class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" v-model="eventRoomOneForm.applicant_town" placeholder="Votre Ville" type="text" aria-label="Not clickable icon">
                </div>
         </div>
        <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
                <label class="uk-form-label" for="form-horizontal-text">Votre Contact</label>
                <div class="uk-inline">
                  <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: phone"></span>
                  <input class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" v-model="eventRoomOneForm.applicant_contact" placeholder="Votre Contact" type="tel" aria-label="Not clickable icon">
                </div>
         </div>
        <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
                <label class="uk-form-label" for="form-horizontal-text">Votre Contact Whatsapp</label>
                <div class="uk-inline">
                  <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: phone"></span>
                  <input class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" v-model="eventRoomOneForm.applicant_wha_contact" placeholder="Votre Whatsapp" type="tel" aria-label="Not clickable icon">
                </div>
         </div>
        <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
                <label class="uk-form-label" for="form-horizontal-text">Date de debut de l'événement</label>
                <div class="uk-inline">
                  <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: calendar"></span>
                  <input class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" v-model="eventRoomOneForm.start_date"  type="date" aria-label="Not clickable icon">
                </div>
         </div>
        <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
                <label class="uk-form-label" for="form-horizontal-text">Date de fin de l'événement</label>
                <div class="uk-inline">
                  <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: calendar"></span>
                  <input class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" v-model="eventRoomOneForm.end_date"  type="date" aria-label="Not clickable icon">
                </div>
         </div>
        <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
                <label class="uk-form-label" for="form-horizontal-text">Heure de debut de l'événement</label>
                <div class="uk-inline">
                  <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: calendar"></span>
                  <input class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" v-model="eventRoomOneForm.start_hour"  type="time" aria-label="Not clickable icon">
                </div>
         </div>
        <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
                <label class="uk-form-label" for="form-horizontal-text">Heure de fin de l'événement</label>
                <div class="uk-inline">
                  <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: calendar"></span>
                  <input class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" v-model="eventRoomOneForm.end_hour"  type="time" aria-label="Not clickable icon">
                </div>
         </div>
        <div class="uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls">
                <label class="uk-form-label" for="form-horizontal-text">Nombre d'invités</label>
                <div class="uk-inline">
                  <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: users"></span>
                  <input class="uk-input uk-input uk-form-width-large uk-border-rounded csa-input" v-model="eventRoomOneForm.guest"  type="number" aria-label="Not clickable icon">
                </div>
         </div>
        <div class="uk-margin uk-width-1-1@s uk-width-1-1@l uk-width-1-1@xl uk-form-controls">
          <label class="uk-form-label" for="form-horizontal-text">Détailles de votre réservation</label>

          <textarea v-model="eventRoomOneForm.desc" class="uk-textarea uk-border-rounded csa-input" rows="5" placeholder="dites nous plus sur votre réservation" aria-label="Textarea"></textarea>
        </div>
        <div>
          <button type="button" class="uk-button uk-button-large csa-btn uk-margin-left uk-text-center" @click="sendEventDatas()">Envoyer</button>
        </div>
      </form>

    </div>
  </div>

</template>

<style scoped>

</style>